import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { InputControl } from '@si-armes/dsfr-react';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import REGEXP_DATE_FR from './regex';

const DateInput = ({
    name,
    required,
    error,
    noFuture,
    label,
    disabled,
    valid,
    validate,
    ...otherProps
}) => {
    const { formState, register } = useFormContext();

    const checkNoFuture = (valeur) => {
        if (valeur && noFuture) {
            const dateDecoupee = valeur.split('/');
            if (
                new Date(dateDecoupee[2], dateDecoupee[1] - 1, dateDecoupee[0]).getTime() >=
                new Date().getTime()
            ) {
                return 'La date renseignée ne doit pas être supérieure à la date du jour';
            }
        }

        return null;
    };

    const checkFormat = (valeur) => {
        if (!valeur || (valeur && valeur.length === 10 && REGEXP_DATE_FR.exec(valeur))) {
            return null;
        }

        return 'Le format est incorrect';
    };

    return (
        <InputControl
            autocomplete="bday"
            label={label}
            placeholder="JJ/MM/AAAA"
            maskFonction={getDateFormatWithSlash}
            {...register(name, {
                required: required ? 'Ce champs est requis' : null,
                validate: {
                    validateFormat: checkFormat,
                    noFuture: checkNoFuture,
                    ...validate,
                },
            })}
            required={required}
            state={formState.errors?.[name] ? 'error' : ''}
            message={formState.errors?.[name]?.message}
            disabled={disabled}
            {...otherProps}
        />
    );
};

DateInput.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    error: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.bool,
    ]),
    /** custom validate de React Hook Form */
    validate: PropTypes.object,
    noFuture: PropTypes.bool,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    valid: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.bool,
    ]),
};

export default DateInput;
